// Import react.
import { useHistory } from "react-router-dom";
// Import services.
import {
	RouterService,
} from '@app/services';
// Import app config
import AppConfig from '@config/app';

interface UseAppRedirectParameters {
	preRedirectCallback?: () => void;
	redirectUrl?: string;
}

interface UseAppRedirectResult {
	redirect: () => void;
};

const useAppRedirect = (params?: UseAppRedirectParameters): UseAppRedirectResult => {
	const history = useHistory();

	const redirect = (): void => {
		if (params !== undefined) {
			if (params.preRedirectCallback !== undefined) {
				params.preRedirectCallback();
			}

			let redirectUrl: string = params.redirectUrl !== undefined ? params.redirectUrl : AppConfig.rootUrl;
			RouterService.getInstance().forceRoute(redirectUrl, history);
		}
	}

	return {
		redirect,
	};
}

// Export parameters.
export {
	UseAppRedirectParameters,
}

// Export results.
export {
	UseAppRedirectResult,
}

export default useAppRedirect;